<template>
  <div>
    <app-header style="z-index: 1000;position: fixed;"
                class="bg-white"></app-header>
    <router-view style="z-index:-1" class="pt-sm-5 pt-5"></router-view>
  </div>
</template>

<script>

  export default {
      components: {
          'app-header': () => import(/*webpackChunkName: "header"*/ '../header/header')
      },
  }
</script>

<style>

</style>
